CancelPaymentController.$inject = ['$scope', '$modalInstance', 'type'];

export default function CancelPaymentController($scope, $modalInstance, type) {
    // this will dismiss the window.
    $scope.type = type;
    $scope.cancel = function () {
        $modalInstance.dismiss();
    };

    // this will remove the beneficiary
    $scope.cancelPayment = function () {
        $modalInstance.close($scope.comments);
    };
}
